var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "webapp" },
    [
      _c(
        "basic-container",
        [
          _c("avue-form-design", {
            attrs: { options: _vm.option },
            on: { submit: _vm.handleSubmit },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }